import React from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';

interface Section {
  value: number; // مقدار هر بخش
  color: string; // رنگ هر بخش
  name: string; // نام هر بخش
}

interface GaugeChartProps {
  value: number; // مقدار ورودی برای نمایش
  label: string; // متن سفارشی برای نمایش زیر گراف
  sections: Section[]; // آرایه بخش‌ها
}

const RADIAN = Math.PI / 180;

// تابع برای رسم عقربه
const needle = (value: number, cx: number, cy: number, iR: number, oR: number) => {
  const total = 100; // مقدار کل
  const ang = 180.0 * (1 - value / total); // زاویه عقربه
  const length = (iR + 2 * oR) / 3; // طول عقربه
  const sin = Math.sin(-RADIAN * ang);
  const cos = Math.cos(-RADIAN * ang);
  const r = 5; // اندازه دایره عقربه
  const x0 = cx + 5; // موقعیت x مرکز عقربه
  const y0 = cy + 5; // موقعیت y مرکز عقربه
  const xba = x0 + r * sin;
  const yba = y0 - r * cos;
  const xbb = x0 - r * sin;
  const ybb = y0 + r * cos;
  const xp = x0 + length * cos;
  const yp = y0 + length * sin;

  return (
    <>
      <circle cx={x0} cy={y0} r={r} stroke="none" />
      <path d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`} stroke="none" />
    </>
  );
};

// نوع Props برای تولتیپ
interface CustomTooltipProps {
  active?: boolean;
  payload?: Array<{ name: string; value: number; color: string }>;
}

// کامپوننت تولتیپ
const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload }) => {
  if (active && payload && payload.length > 0) {
    const { name, value, color } = payload[0]; // استفاده از destructuring
    return (
      <div style={{
        backgroundColor: 'gray',
        padding: '5px',
        width:'100px',
        height:'50px',
        borderRadius: '5px',
        color: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}>
        <p style={{ margin: 0, fontWeight: 'bold' }}>{name}</p>
        <p style={{ margin: 0 }}>{`مقدار: ${value}`}</p>
      </div>
    );
  }
  return null;
};

// کامپوننت گراف
const GaugeChart: React.FC<GaugeChartProps> = ({ value, label, sections }) => {
  const cx = 150; // موقعیت x مرکز دایره
  const cy = 200; // موقعیت y مرکز دایره
  const iR = 50; // شعاع داخلی
  const oR = 100; // شعاع خارجی

  return (
    <div style={{ textAlign: 'center' }}>
      <PieChart width={350} height={300}>
        {/* <Tooltip content={<CustomTooltip />} /> */}
        <Pie
          dataKey="value"
          startAngle={180}
          endAngle={0}
          data={sections}
          cx={cx}
          cy={cy}
          innerRadius={iR}
          outerRadius={oR}
          fill="#8884d8"
          stroke="none"
        >
          {sections.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        {needle(value, cx, cy, iR, oR)}
        <text x={cx} y={cy + 35} textAnchor="middle" fontWeight={600} fontSize={15}>
          {label}: {value}%
        </text>
      </PieChart>
    </div>
  );
};

export default GaugeChart;
